import { render, staticRenderFns } from "./EmptyCatalog.vue?vue&type=template&id=37fa8618&scoped=true&"
import script from "./EmptyCatalog.vue?vue&type=script&lang=ts&"
export * from "./EmptyCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyCatalog.vue?vue&type=style&index=0&id=37fa8618&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa8618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
